const lotsConstants = t => ({
  ALL_IN_RANK_COLUMN_HEADER: t('general.all_in_current_rank'),
  ALL_IN_RANK_SUGGESTION_COLUMN_HEADER: t('general.all_in_rank_suggestion_title'),
  AWARDED: t('general.status'),
  AWARDED_LINE_ITEM_PRICE: t('general.awarded_line_item_price'),
  AWARDED_QUANTITY: t('general.awarded_quantity'),
  AWARDING_INFO_HEADERS: [
    { header: t('general.status'), key: t('general.status') },
    { header: t('general.awarded_quantity'), key: t('general.awarded_quantity') },
    { header: t('general.awarded_line_item_price'), key: t('general.awarded_line_item_price') },
  ],
  BATCH_SIZE: 1000,
  CURRENCY_CODE_HEADER: t('general.currency_code'),
  DEFAULT_HEADERS: [
    { header: t('general.lot_name'), key: t('general.lot_name') },
    { header: t('general.lot_id'), key: t('general.lot_id') },
    { header: t('general.line_item_name'), key: t('general.line_item_name') },
    { header: t('general.line_item_id'), key: t('general.line_item_id') }
  ],
  DISCOUNT_HEADER: t('general.discount_per_unit'),
  EDITABLE_HEADERS: [
    [
      { header: t('general.price_per_unit'), key: t('general.price_per_unit') },
      { header: t('general.discount_per_unit'), key: t('general.discount_per_unit') },
      { header: t('general.surcharge'), key: t('general.surcharge') },
      { header: t('general.quantity_key'), key: t('general.quantity_key') }
    ],
    { header: t('general.no_quote'), key: t('general.no_quote') }
  ],
  IS_REQUIRED_HEADER: t('general.is_required'),
  ITEMS_PER_UNIT_HEADER: t('general.quantity_key'),
  LINE_ITEM_ID_HEADER: t('general.line_item_id'),
  LINE_ITEM_NAME_HEADER: t('general.line_item_name'),
  LINE_ITEM_PRICE: t('line_items.line_item_price'),
  LOGISTIC_CHARGE_HEADER: t('general.surcharge'),
  LOT_ID_HEADER: t('general.lot_id'),
  LOT_NAME_HEADER: t('general.lot_name'),
  NO_BID_HEADER: t('general.no_quote'),
  NO_BID_HEADERS: [ // TODO: Verify and remove not used anywhere in the code
    { header: t('general.no_quote'), key: t('general.no_quote') }
  ],
  NUMERIC_EDITABLE_HEADERS: [
    { header: t('general.price_per_unit'), key: t('general.price_per_unit') },
    { header: t('general.discount_per_unit'), key: t('general.discount_per_unit') },
    { header: t('general.surcharge'), key: t('general.surcharge') },
    { header: t('general.quantity_key'), key: t('general.quantity_key') }
  ],
  ORIGINAL_ITEMS_PER_UNIT_HEADER: t('general.original_quantity_key'),
  ORIGINAL_SUGGESTED_PRICE_PER_UNIT_HEADER: t('line_items.original_suggested_price_per_unit'),
  PARALLEL_CHUNKS: 10,
  PRICE_PER_UNIT_HEADER: t('general.price_per_unit'),
  PRICING_HEADERS: [ // TODO: Verify and remove not used anywhere in the code
    { header: t('line_items.quantity_of_items'), key: t('line_items.quantity_of_items') },
    {
      header: t('line_items.original_suggested_price_per_unit'),
      key: t('line_items.original_suggested_price_per_unit')
    },
    { header: t('line_items.suggested_price_per_unit'), key: t('line_items.suggested_price_per_unit') },
    { header: t('general.price_per_unit'), key: t('general.price_per_unit') },
    { header: t('general.discount_per_unit'), key: t('general.discount_per_unit') },
    { header: t('general.surcharge'), key: t('general.surcharge') },
    { header: t('general.original_quantity_key'), key: t('general.original_quantity_key') },
    { header: t('line_items.quantity_of_items'), key: t('general.quantity_key') },
    { header: t('line_items.line_item_price'), key: t('line_items.line_item_price') }
  ],
  PROPOSED_PRICE_HEADER: t('general.proposed_price'),
  PROPOSED_PRICE_PER_UNIT_HEADER: t('general.proposed_price_per_unit'),
  QUANTITY_OF_ITEMS_HEADER: t('line_items.quantity_of_items'),
  QUANTITY_OF_UNITS_HEADER: t('line_items.quantity_of_units'),
  QUOTED_QUANTITY_OF_ITEMS_HEADER: t('line_items.quoted_quantity_of_items'),
  QUOTED_QUANTITY_OF_UNITS_HEADER: t('line_items.quoted_quantity_of_units'),
  RANK_COLUMN_HEADER: t('general.current_rank'),
  RANK_HEADERS: [
    { header: t('general.current_rank'), key: 'rank' },
    { header: t('general.rank_suggestion_title'), key: 'suggest' }
  ],
  RANK_SUGGESTION_COLUMN_HEADER: t('general.rank_suggestion_title'),
  SUGGESTED_PRICE_PER_UNIT_HEADER: t('line_items.suggested_price_per_unit'),
  UNIT_OF_MEASURE_HEADER: t('general.uom'),
  UOM_AND_QUANTITY_UNITS_HEADERS: [
    { header: t('general.uom'), key: t('general.uom') },
    { header: t('line_items.quantity_of_units'), key: t('line_items.quantity_of_units') }
  ],
  UOM_HEADERS: [
    { header: t('general.uom'), key: t('general.uom') }
  ]
});

export default lotsConstants;
